/**
 * Created by weihuang on 2017/11/2.
 */
import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./router/routes";
import { flattenRouterPath } from "./utils/utils";
import { isLogin, haveAuthority } from "./utils/authority";
import { setToken, setEmail, gotLogin } from "./utils/authority";
const router = new VueRouter({
  routes
});

const getQueryString = name => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.hash.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

// 定义路由导航，用于登录拦截
const pathAuthority = flattenRouterPath(routes);

router.beforeEach((to, from, next) => {
  let token = to.query.token;
  let email = to.query.email;
  if (token) {
    setToken(token);
    setEmail(email);
  }

  const nowAuthority = isLogin() ? "admin" : "guest";
  const nowPathAuthority = pathAuthority[to.path];

  if (haveAuthority(nowAuthority, nowPathAuthority || "admin")) {
    next();
  } else {
    //next()
    //next(pathAuthority.redirect_path);

    gotLogin();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/routes.js